<div class="min-h-screen bg-slate-50 px-4 py-6 md:px-6 xl:px-8">
    <div class="mx-auto flex max-w-[1600px] flex-col gap-6">
        <div class="flex flex-col gap-2">
            <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                <div class="flex flex-col gap-2">
                    <h1 class="text-3xl font-bold text-slate-900 md:text-2xl">Admin Dashboard</h1>
                    <!-- <p class="text-sm text-slate-500">Manage cities, users, onboarding, and model availability.</p> -->
                </div>

                <button
                    type="button"
                    class="inline-flex items-center justify-center gap-2 self-start rounded-2xl border border-white/20 bg-gradient-to-r from-sky-600 to-pink-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm md:self-auto"
                    (click)="startCreateUser()"
                >
                    <i class="pi pi-plus text-xs"></i>
                    <span>Onboard new user</span>
                </button>
            </div>
        </div>

        <div
            *ngIf="actionVisible()"
            class="flex items-start justify-between gap-3 rounded-2xl border px-4 py-3 text-sm shadow-sm"
            [ngClass]="
                actionTone === 'success'
                    ? 'border-emerald-200 bg-emerald-50 text-emerald-800'
                    : 'border-sky-200 bg-sky-50 text-sky-800'
            "
        >
            <div class="min-w-0 flex-1">
                {{ actionMessage }}
            </div>

            <button
                type="button"
                class="inline-flex h-6 w-6 items-center justify-center rounded-full text-current transition hover:bg-black/5"
                (click)="dismissActionMessage()"
                aria-label="Close message"
            >
                <i class="pi pi-times text-xs"></i>
            </button>
        </div>

        <section class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-5 2xl:grid-cols-5">
            <div
                *ngFor="let card of summaryCards()"
                class="overflow-hidden rounded-3xl border bg-white p-4 shadow-sm"
                [ngClass]="card.borderClass"
            >
                <div class="flex items-start justify-between gap-3">
                    <div>
                        <div class="text-xs font-semibold uppercase tracking-wide text-slate-500">{{ card.label }}</div>
                        <div class="mt-3 text-3xl font-bold text-slate-900">{{ card.value }}</div>
                    </div>
                    <div class="rounded-2xl p-3" [ngClass]="card.iconClass">
                        <i class="{{ card.icon }} text-lg"></i>
                    </div>
                </div>
            </div>
        </section>


        <section class="grid grid-cols-1 gap-6 xl:grid-cols-2 xl:items-stretch">
            <div class="flex h-full flex-col rounded-3xl border border-slate-200 bg-white p-5 shadow-lg">
                <div class="mb-5 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                    <div>
                        <h2 class="text-lg font-semibold text-slate-900">Cities</h2>
                        <p class="text-sm text-slate-500">Click a city to view and update assigned users.</p>
                    </div>

                    <div class="w-full md:w-72">
                        <input
                            type="text"
                            class="w-full rounded-2xl border border-slate-200 px-4 py-2.5 text-sm outline-none transition focus:border-sky-400"
                            [ngModel]="citySearchTerm"
                            (ngModelChange)="onCitySearchChange($event)"
                            placeholder="Search city or country"
                        />
                    </div>
                </div>

                <div class="flex-1 overflow-hidden rounded-2xl border border-slate-200">
                    <table class="min-w-full divide-y divide-slate-200">
                        <thead class="bg-slate-50">
                            <tr>
                                <th class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">City</th>
                                <th class="px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">T0</th>
                                <th class="px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">Enhanced Model</th>
                                <th class="px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">T6</th>
                                <th class="px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">Data Upload</th>
                                <th class="px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">Users</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-100 bg-white">
                            <tr
                                *ngFor="let city of getVisibleCities()"
                                (click)="selectCity(city)"
                                class="cursor-pointer transition hover:bg-slate-50"
                                [ngClass]="{ 'bg-sky-50': isSelectedCity(city.id) }"
                            >
                                <td class="px-4 py-3">
                                    <div class="font-semibold text-slate-900">{{ city.name }}</div>
                                    <div class="text-xs text-slate-500">{{ city.countryName }} · {{ city.citySpecification | titlecase }}</div>
                                </td>

                                <td class="px-3 py-3 text-center">
                                    <button
                                        type="button"
                                        class="inline-flex items-center justify-center text-lg transition hover:scale-110"
                                        [ngClass]="city.t0Active ? 'text-emerald-600' : 'text-rose-500'"
                                        (click)="$event.stopPropagation(); toggleCityModel(city, 't0Active')"
                                    >
                                        <i class="pi" [ngClass]="city.t0Active ? 'pi-check-circle' : 'pi-times-circle'"></i>
                                    </button>
                                </td>

                                <td class="px-3 py-3 text-center">
                                    <button
                                        type="button"
                                        class="inline-flex items-center justify-center text-lg transition hover:scale-110"
                                        [ngClass]="city.t3Active ? 'text-emerald-600' : 'text-rose-500'"
                                        (click)="$event.stopPropagation(); toggleCityModel(city, 't3Active')"
                                    >
                                        <i class="pi" [ngClass]="city.t3Active ? 'pi-check-circle' : 'pi-times-circle'"></i>
                                    </button>
                                </td>

                                <td class="px-3 py-3 text-center">
                                    <button
                                        type="button"
                                        class="inline-flex items-center justify-center text-lg transition hover:scale-110"
                                        [ngClass]="city.t6Active ? 'text-emerald-600' : 'text-rose-500'"
                                        (click)="$event.stopPropagation(); toggleCityModel(city, 't6Active')"
                                    >
                                        <i class="pi" [ngClass]="city.t6Active ? 'pi-check-circle' : 'pi-times-circle'"></i>
                                    </button>
                                </td>

                                <td class="px-3 py-3 text-center">
                                    <button
                                        type="button"
                                        class="inline-flex items-center justify-center text-lg transition hover:scale-110"
                                        [ngClass]="city.dataUploadActive ? 'text-emerald-600' : 'text-rose-500'"
                                        (click)="$event.stopPropagation(); toggleCityModel(city, 'dataUploadActive')"
                                    >
                                        <i class="pi" [ngClass]="city.dataUploadActive ? 'pi-check-circle' : 'pi-times-circle'"></i>
                                    </button>
                                </td>

                                <td class="px-3 py-3 text-center">
                                    <span class="inline-flex min-w-10 items-center justify-center rounded-full bg-sky-50 px-2 py-1 text-xs font-semibold text-sky-700">
                                        {{ getCityUserCount(city.id) }}
                                    </span>
                                </td>
                            </tr>

                            <tr *ngIf="!getVisibleCities().length">
                                <td colspan="6" class="px-4 py-8 text-center text-sm text-slate-500">
                                    No cities found.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="mt-4 flex flex-wrap items-center justify-between gap-3">
                    <div class="text-xs text-slate-500">
                        Showing {{ getVisibleCities().length }} of {{ cities().length }} cities
                    </div>

                    <div class="flex flex-wrap items-center gap-2" *ngIf="getCityPageNumbers().length > 1">
                        <button
                            type="button"
                            class="rounded-xl border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:border-sky-300 hover:text-sky-700 disabled:cursor-not-allowed disabled:opacity-50"
                            [disabled]="cityPage === 1"
                            (click)="goToCityPage(cityPage - 1)"
                        >
                            Previous
                        </button>

                        <button
                            *ngFor="let page of getCityPageNumbers()"
                            type="button"
                            class="rounded-xl border px-3 py-1.5 text-xs font-semibold transition"
                            [ngClass]="page === cityPage ? 'border-sky-300 bg-sky-50 text-sky-700' : 'border-slate-200 text-slate-600 hover:border-sky-300 hover:text-sky-700'"
                            (click)="goToCityPage(page)"
                        >
                            {{ page }}
                        </button>

                        <button
                            type="button"
                            class="rounded-xl border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:border-sky-300 hover:text-sky-700 disabled:cursor-not-allowed disabled:opacity-50"
                            [disabled]="cityPage === getCityPageNumbers().length"
                            (click)="goToCityPage(cityPage + 1)"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>

            <div class="flex h-full flex-col rounded-3xl border border-slate-200 bg-white p-5 shadow-lg">
                <div class="mb-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                    <div>
                        <h2 class="text-lg font-semibold text-slate-900">Users</h2>
                        <p class="text-sm text-slate-500">Manage user access by city and model.</p>
                    </div>

                    <div class="w-full md:w-72">
                        <input
                            type="text"
                            class="w-full rounded-2xl border border-slate-200 px-4 py-2.5 text-sm outline-none transition focus:border-sky-400"
                            [ngModel]="userSearchTerm"
                            (ngModelChange)="onUserSearchChange($event)"
                            placeholder="Search user or email"
                        />
                    </div>
                </div>

                <div class="flex-1 overflow-hidden rounded-2xl border border-slate-200">
                    <table class="min-w-full divide-y divide-slate-200">
                        <thead class="bg-slate-50">
                            <tr>
                                <th class="px-3 py-2.5 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500">User</th>
                                <th class="px-2 py-2.5 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500">Status</th>
                                <th class="px-2 py-2.5 text-center text-[11px] font-semibold uppercase tracking-wide text-slate-500">Assigned cities</th>
                                <th class="px-2 py-2.5 text-center text-[11px] font-semibold uppercase tracking-wide text-slate-500">Action</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-100 bg-white">
                            <tr *ngFor="let user of getVisibleUsers()">
                                <td class="px-3 py-2.5">
                                    <div class="font-medium text-slate-900">{{ getDisplayName(user.email) }}</div>
                                    <div class="text-[11px] text-slate-500">{{ user.email }}</div>
                                </td>

                                <td class="px-2 py-2.5">
                                    <span
                                        class="inline-flex rounded-full px-2 py-1 text-[11px] font-medium"
                                        [ngClass]="user.status === 'active' ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'"
                                    >
                                        {{ user.status | titlecase }}
                                    </span>
                                </td>

                                <td class="px-2 py-2.5 text-center">
                                    <span
                                        class="inline-flex cursor-help items-center rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold text-slate-700"
                                        [pTooltip]="getAssignedCitiesTooltip(user)"
                                        tooltipPosition="top"
                                    >
                                        {{ getSelectedCityCount(user) }}
                                    </span>
                                </td>

                                <td class="px-2 py-2.5">
                                    <div class="flex items-center justify-center gap-1">
                                        <button
                                            pButton
                                            type="button"
                                            icon="pi pi-pencil"
                                            class="p-button-text p-button-rounded p-button-sm"
                                            pTooltip="Edit user"
                                            tooltipPosition="top"
                                            (click)="editUser(user)"
                                        ></button>

                                        <button
                                            type="button"
                                            class="admin-icon-btn text-rose-600 hover:bg-rose-50"
                                            pTooltip="Delete user"
                                            tooltipPosition="top"
                                            (click)="confirmDeleteUser($event, user)">
                                            <i class="pi pi-trash"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            <tr *ngIf="!getVisibleUsers().length">
                                <td colspan="4" class="px-4 py-8 text-center text-sm text-slate-500">
                                    No users found.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="mt-4 flex flex-wrap items-center justify-between gap-3">
                    <div class="text-xs text-slate-500">
                        Showing {{ getVisibleUsers().length }} of {{ getFilteredUsers().length }} users
                    </div>

                    <div class="flex flex-wrap items-center gap-2" *ngIf="getUserPageNumbers().length > 1">
                        <button
                            type="button"
                            class="rounded-xl border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:border-sky-300 hover:text-sky-700 disabled:cursor-not-allowed disabled:opacity-50"
                            [disabled]="userPage === 1"
                            (click)="goToUserPage(userPage - 1)"
                        >
                            Previous
                        </button>

                        <button
                            *ngFor="let page of getUserPageNumbers()"
                            type="button"
                            class="rounded-xl border px-3 py-1.5 text-xs font-semibold transition"
                            [ngClass]="page === userPage ? 'border-sky-300 bg-sky-50 text-sky-700' : 'border-slate-200 text-slate-600 hover:border-sky-300 hover:text-sky-700'"
                            (click)="goToUserPage(page)"
                        >
                            {{ page }}
                        </button>

                        <button
                            type="button"
                            class="rounded-xl border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:border-sky-300 hover:text-sky-700 disabled:cursor-not-allowed disabled:opacity-50"
                            [disabled]="userPage === getUserPageNumbers().length"
                            (click)="goToUserPage(userPage + 1)"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <p-dialog
            [visible]="editorDialogVisible()"
            (visibleChange)="editorDialogVisible.set($event)"
            [modal]="true"
            [draggable]="false"
            [resizable]="false"
            [dismissableMask]="true"
            [closable]="true"
            [style]="{ width: '58rem', maxWidth: '92vw' }"
            (onHide)="closeEditorDialog()"
        >
            <ng-template pTemplate="header">
                <div class="flex items-center justify-between gap-3">
                    <div>
                        <div class="text-lg font-semibold text-slate-900">Onboard / Edit user</div>
                        <div class="text-sm text-slate-500">Create and update user access.</div>
                    </div>

                    <span
                        *ngIf="formMode() !== 'idle'"
                        class="inline-flex rounded-full px-2.5 py-1 text-xs font-semibold"
                        [ngClass]="formMode() === 'edit' ? 'bg-violet-50 text-violet-700' : 'bg-sky-50 text-sky-700'"
                    >
                        {{ formMode() === 'edit' ? 'Edit mode' : 'New user' }}
                    </span>
                </div>
            </ng-template>

            <div *ngIf="editorLoading()" class="py-10 text-center text-sm text-slate-500">
                Loading user details...
            </div>

            <div *ngIf="!editorLoading()" class="space-y-5">
                <div class="space-y-4">
                    @if (formMode() === 'create') {
                    <div>
                        <label class="mb-2 block text-sm font-medium text-slate-700">Emails</label>
                        <textarea
                            rows="3"
                            class="w-full rounded-2xl border border-slate-200 px-4 py-2.5 text-sm outline-none transition focus:border-sky-400"
                            [(ngModel)]="editorForm.emailsRaw"
                            (keydown)="onEmailKeydown($event)"
                            (paste)="onEmailPaste($event)"
                            (blur)="onEmailsBlur()"
                            placeholder="jane.doe@example.com, john.smith@example.com"></textarea>

                        <p class="mt-1.5 text-[11px] leading-relaxed text-slate-500">
                            Add one or more emails separated by a <span class="font-medium">comma</span> or a new
                            line to onboard them together with the same city access.<br />
                            <span class="text-slate-400">Example: jane.doe&#64;example.com, john.smith&#64;example.com</span>
                        </p>

                        <div class="mt-1 text-[11px] text-slate-500">
                            {{ parsedEmailCount() }} valid email(s) detected.
                        </div>

                        @if (emailInputWarning()) {
                        <div class="mt-1 flex items-center gap-1 text-[11px] font-medium text-rose-600">
                            <i class="pi pi-exclamation-circle text-[10px]"></i>
                            {{ emailInputWarning() }}
                        </div>
                        }

                        @if (invalidEmails().length) {
                        <div class="mt-1 flex items-start gap-1 text-[11px] font-medium text-amber-600">
                            <i class="pi pi-info-circle mt-0.5 text-[10px]"></i>
                            <span>Invalid format: {{ invalidEmails().join(', ') }}</span>
                        </div>
                        }

                        @if (duplicateEmails().length) {
                        <div class="mt-1 flex items-start gap-1 text-[11px] font-medium text-rose-600">
                            <i class="pi pi-exclamation-triangle mt-0.5 text-[10px]"></i>
                            <span>Already onboarded: {{ duplicateEmails().join(', ') }}</span>
                        </div>
                        }
                    </div>
                    } @else {
                    <div>
                        <label class="mb-2 block text-sm font-medium text-slate-700">Email</label>
                        <input
                            type="email"
                            class="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-2.5 text-sm text-slate-600"
                            [ngModel]="editorForm.email"
                            readonly />
                    </div>
                    }

                    <div class="grid grid-cols-1 gap-3 md:grid-cols-[auto_auto_auto] md:items-end md:justify-start">
                        <div>
                            <label class="mb-2 block text-sm font-medium text-slate-700">Status</label>
                            <div class="inline-flex rounded-full border border-slate-200 bg-white p-1">
                                <button
                                    type="button"
                                    class="rounded-full px-3 py-1 text-xs font-semibold transition"
                                    [ngClass]="
                                        editorForm.status === 'active'
                                            ? 'bg-emerald-500 text-white'
                                            : 'text-slate-600 hover:bg-slate-100'
                                    "
                                    (click)="setEditorStatus('active')"
                                >
                                    Active
                                </button>

                                <button
                                    type="button"
                                    class="rounded-full px-3 py-1 text-xs font-semibold transition"
                                    [ngClass]="
                                        editorForm.status === 'inactive'
                                            ? 'bg-amber-500 text-white'
                                            : 'text-slate-600 hover:bg-slate-100'
                                    "
                                    (click)="setEditorStatus('inactive')"
                                >
                                    Inactive
                                </button>
                            </div>
                        </div>

                        <label class="inline-flex cursor-pointer items-center gap-2 text-sm font-medium text-slate-700 md:pb-1">
                            <input
                                type="checkbox"
                                class="h-4 w-4 rounded border-slate-300"
                                [ngModel]="editorForm.allAccess"
                                (ngModelChange)="toggleEditorGlobalAccess($event)"
                            />
                            <span>Enable all access</span>
                        </label>

                        <label class="inline-flex cursor-pointer items-center gap-2 text-sm font-medium text-slate-700 md:pb-1">
                            <input
                                type="checkbox"
                                class="h-4 w-4 rounded border-slate-300"
                                [disabled]="editorForm.allAccess"
                                [ngModel]="editorForm.selectAllCities"
                                (ngModelChange)="toggleEditorSelectAllCities($event)"
                            />
                            <span>Select all cities</span>
                        </label>
                    </div>
                </div>

                <div>
                    <div class="mb-3 flex items-center justify-between">
                        <label class="block text-sm font-medium text-slate-700">Assign cities and access</label>
                        <span class="rounded-full bg-white px-2 py-0.5 text-[11px] font-semibold text-slate-600">
                            {{ getSelectedEditorCityCount() }} selected
                        </span>
                    </div>

                    <div class="space-y-4 rounded-2xl border border-slate-200 bg-white p-4">
                        <div
                            class="grid grid-cols-1 gap-4 md:grid-cols-[minmax(0,6fr)_minmax(340px,4fr)]"
                            [ngClass]="editorForm.allAccess ? 'pointer-events-none select-none opacity-60' : ''"
                        >
                            <div class="space-y-3">
                                <input
                                    type="text"
                                    class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none transition focus:border-sky-400"
                                    [ngModel]="editorCitySearchTerm"
                                    (ngModelChange)="onEditorCitySearchChange($event)"
                                    placeholder="Search city"
                                />

                                <div class="max-h-[240px] overflow-y-auto rounded-xl border border-slate-100 bg-slate-50 p-3">
                                    <div class="flex flex-wrap gap-2">
                                        <button
                                            *ngFor="let city of getFilteredEditorCities()"
                                            type="button"
                                            class="rounded-full border px-2.5 py-1 text-[11px] font-semibold leading-5 transition"
                                            [ngClass]="
                                                isEditorCitySelected(city.cityId)
                                                    ? 'border-sky-300 bg-sky-500 text-white'
                                                    : isEditorCityAssigned(city)
                                                      ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
                                                      : 'border-slate-200 bg-white text-slate-600 hover:border-sky-300 hover:text-sky-700'
                                            "
                                            (click)="selectEditorCity(city.cityId)"
                                        >
                                            {{ city.cityName }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="rounded-2xl border border-slate-200 bg-gradient-to-br from-white to-slate-50 p-4 shadow-sm">
                                @if (hasSelectedEditorCities()) {
                                <div class="mb-3">
                                    <!-- <div class="mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                                        Selected cities ({{ getSelectedEditorCities().length }})
                                    </div> -->
                                    <div class="flex flex-wrap gap-1.5">
                                        <span
                                            *ngFor="let city of getSelectedEditorCities()"
                                            class="inline-flex items-center gap-1 rounded-full border border-sky-200 bg-sky-50 px-2 py-0.5 text-[11px] font-semibold text-sky-700"
                                        >
                                            {{ city.cityName }}
                                            <button
                                                type="button"
                                                class="inline-flex h-3.5 w-3.5 items-center justify-center rounded-full text-sky-600 transition hover:bg-sky-200"
                                                (click)="removeSelectedEditorCity(city.cityId)"
                                                aria-label="Remove city"
                                            >
                                                <i class="pi pi-times text-[9px]"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>

                                <div class="mb-3 flex items-center justify-between">
                                    <div class="text-[11px] font-semibold uppercase tracking-wide text-slate-500">                                        Selected cities ({{ getSelectedEditorCities().length }})</div>
                                    <button
                                        type="button"
                                        class="inline-flex items-center whitespace-nowrap rounded-full border px-3 py-1 text-[10px] font-semibold transition"
                                        [ngClass]="
                                            isDraftAccessActive('allAccess')
                                                ? 'border-sky-300 bg-sky-500 text-white'
                                                : 'border-slate-200 bg-white text-slate-600 hover:border-sky-300 hover:bg-sky-50'
                                        "
                                        (click)="toggleDraftAccess('allAccess')"
                                    >
                                        All Access
                                    </button>
                                </div>

                                <div class="grid grid-cols-4 gap-2">
                                    <button
                                        type="button"
                                        class="flex min-h-[30px] items-center justify-center whitespace-nowrap rounded-xl border px-2 py-2 text-[11px] font-semibold transition"
                                        [ngClass]="
                                            isDraftAccessActive('t0Access')
                                                ? 'border-sky-300 bg-sky-500 text-white shadow-sm'
                                                : 'border-slate-200 bg-white text-slate-600 hover:border-sky-300 hover:bg-sky-50'
                                        "
                                        (click)="toggleDraftAccess('t0Access')"
                                    >
                                        T0
                                    </button>

                                    <button
                                        type="button"
                                        class="flex min-h-[30px] items-center justify-center whitespace-nowrap rounded-xl border px-2 py-2 text-[11px] font-semibold transition"
                                        [ngClass]="
                                            isDraftAccessActive('t3Access')
                                                ? 'border-sky-300 bg-sky-500 text-white shadow-sm'
                                                : 'border-slate-200 bg-white text-slate-600 hover:border-sky-300 hover:bg-sky-50'
                                        "
                                        (click)="toggleDraftAccess('t3Access')"
                                    >
                                        Enhanced
                                    </button>

                                    <button
                                        type="button"
                                        class="flex min-h-[30px] items-center justify-center whitespace-nowrap rounded-xl border px-2 py-2 text-[11px] font-semibold transition"
                                        [ngClass]="
                                            isDraftAccessActive('t6Access')
                                                ? 'border-sky-300 bg-sky-500 text-white shadow-sm'
                                                : 'border-slate-200 bg-white text-slate-600 hover:border-sky-300 hover:bg-sky-50'
                                        "
                                        (click)="toggleDraftAccess('t6Access')"
                                    >
                                        T6
                                    </button>

                                    <button
                                        type="button"
                                        class="flex min-h-[30px] items-center justify-center whitespace-nowrap rounded-xl border px-2 py-2 text-[11px] font-semibold transition"
                                        [ngClass]="
                                            isDraftAccessActive('dataUploadAccess')
                                                ? 'border-sky-300 bg-sky-500 text-white shadow-sm'
                                                : 'border-slate-200 bg-white text-slate-600 hover:border-sky-300 hover:bg-sky-50'
                                        "
                                        (click)="toggleDraftAccess('dataUploadAccess')"
                                    >
                                        Data Upload
                                    </button>
                                </div>

                                <button
                                    type="button"
                                    class="mt-3 w-full rounded-xl bg-gradient-to-r from-sky-600 to-pink-600 px-3 py-2 text-xs font-semibold text-white shadow-sm"
                                    (click)="addSelectedCityAccess()"
                                >
                                    {{ getDraftActionLabel() }}
                                </button>
                                } @else {
                                <div class="flex min-h-[180px] items-center justify-center text-center text-xs text-slate-500">
                                    Select one or more cities from the left to configure access.
                                </div>
                                }
                            </div>
                        </div>

                        <div *ngIf="editorForm.allAccess" class="rounded-xl bg-sky-50 px-3 py-2 text-xs font-medium text-sky-700">
                            All access is enabled. City-level access selection is locked.
                        </div>

                        <div
                            class="overflow-hidden rounded-2xl border border-slate-200"
                            *ngIf="!editorForm.allAccess && getAssignedEditorCities().length; else noAssignedCities"
                        >
                            <table class="min-w-full divide-y divide-slate-200">
                                <thead class="bg-slate-50">
                                    <tr>
                                        <th class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">City</th>
                                        <th class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">Added access</th>
                                        <th class="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">Action</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-slate-100 bg-white">
                                    <tr *ngFor="let city of getAssignedEditorCities()">
                                        <td class="px-4 py-3">
                                            <div class="font-medium text-slate-900">{{ city.cityName }}</div>
                                            <div class="text-xs text-slate-500">{{ city.countryName }}</div>
                                        </td>

                                        <td class="px-4 py-3">
                                            <div class="flex flex-wrap gap-1.5">
                                                <span
                                                    *ngFor="let badge of getEditorAccessBadges(city)"
                                                    class="rounded-full bg-sky-50 px-2 py-0.5 text-[10px] font-semibold text-sky-700"
                                                >
                                                    {{ badge }}
                                                </span>
                                            </div>
                                        </td>

                                        <td class="px-4 py-3">
                                            <div class="flex items-center justify-center gap-2">
                                                <button
                                                    type="button"
                                                    class="rounded-lg border border-slate-200 px-2.5 py-1 text-[11px] font-semibold text-slate-600 transition hover:border-sky-300 hover:text-sky-700"
                                                    (click)="editAssignedCity(city.cityId)"
                                                >
                                                    Edit
                                                </button>

                                                <button
                                                    type="button"
                                                    class="rounded-lg border border-rose-200 px-2.5 py-1 text-[11px] font-semibold text-rose-600 transition hover:bg-rose-50"
                                                    (click)="removeAssignedCity(city.cityId)"
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <ng-template #noAssignedCities>
                            <div
                                *ngIf="!editorForm.allAccess"
                                class="rounded-xl border border-dashed border-slate-200 bg-slate-50 px-4 py-6 text-center text-sm text-slate-500"
                            >
                                No cities added yet.
                            </div>
                        </ng-template>
                    </div>
                </div>

                <div class="flex justify-end gap-2 pt-2">
                    <button
                        type="button"
                        class="rounded-xl border border-slate-200 px-4 py-2 text-sm font-medium text-slate-600 transition hover:border-slate-300"
                        (click)="cancelEditor()"
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        class="rounded-xl bg-sky-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-sky-700 disabled:cursor-not-allowed disabled:opacity-60"
                        [disabled]="savingEditor()"
                        (click)="saveUser()"
                    >
                        {{ savingEditor() ? 'Saving...' : formMode() === 'edit' ? 'Update user' : 'Create user' }}
                    </button>
                </div>
            </div>
        </p-dialog>

        <p-dialog
            [visible]="cityDialogVisible()"
            (visibleChange)="cityDialogVisible.set($event)"
            [modal]="true"
            [draggable]="false"
            [resizable]="false"
            [style]="{ width: '56rem', maxWidth: '92vw' }"
            [dismissableMask]="true"
            [closable]="true"
            (onHide)="closeCityDialog()"
        >
            <ng-template pTemplate="header">
                <div class="flex flex-col">
                    <span class="text-lg font-semibold text-slate-900">
                        {{ selectedCity()?.name || 'City access details' }}
                    </span>
                    <span class="text-sm text-slate-500">
                        {{ selectedCity()?.countryName }} · {{ selectedCity()?.citySpecification | titlecase }}
                    </span>
                </div>
            </ng-template>

            <div *ngIf="selectedCity()" class="space-y-4">
                <div class="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-3 md:flex-row md:items-center md:justify-between">
                    <div class="flex flex-wrap items-center gap-2">
                        <div class="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-slate-700">
                            <span class="text-slate-400">Assigned users</span>
                            <span class="rounded-full bg-sky-50 px-2 py-0.5 text-sky-700">
                                {{ filteredSelectedCityUsers.length }}
                            </span>
                        </div>

                        <div class="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-slate-700">
                            <span class="text-slate-400">Models</span>
                            <span [ngClass]="selectedCity()?.t0Active ? 'text-emerald-600' : 'text-slate-400'">T0</span>
                            <span [ngClass]="selectedCity()?.t3Active ? 'text-emerald-600' : 'text-slate-400'">Enhanced</span>
                            <span [ngClass]="selectedCity()?.t6Active ? 'text-emerald-600' : 'text-slate-400'">T6</span>
                            <span [ngClass]="selectedCity()?.dataUploadActive ? 'text-emerald-600' : 'text-slate-400'">Upload</span>
                        </div>
                    </div>

                    <div class="w-full md:w-72">
                        <input
                            type="text"
                            class="w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm outline-none transition focus:border-sky-400"
                            [ngModel]="cityUserSearchTerm"
                            (ngModelChange)="onCityUserSearchChange($event)"
                            placeholder="Search users"
                        />
                    </div>
                </div>

                <div class="overflow-hidden rounded-2xl border border-slate-200 bg-white">
                    <table class="min-w-full divide-y divide-slate-200">
                        <thead class="bg-slate-50">
                            <tr>
                                <th class="px-3 py-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">User</th>
                                <th class="px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">All</th>
                                <th class="px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">T0</th>
                                <th class="px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">Enhanced</th>
                                <th class="px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">T6</th>
                                <th class="px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide text-slate-500">Upload</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-100 bg-white">
                            <tr *ngFor="let row of getVisibleSelectedCityUsers()">
                                <td class="px-3 py-3">
                                    <div class="font-medium text-slate-900">{{ getDisplayName(row.email) }}</div>
                                    <div class="text-xs text-slate-500">{{ row.email }}</div>
                                </td>

                                <td class="px-3 py-3 text-center">
                                    <input
                                        type="checkbox"
                                        class="h-4 w-4 cursor-pointer rounded border-slate-300"
                                        [ngModel]="getDraftPermission(row).allAccess"
                                        (ngModelChange)="updateAllAccess(row, $event)"
                                    />
                                </td>

                                <td class="px-3 py-3 text-center">
                                    <input
                                        type="checkbox"
                                        class="h-4 w-4 cursor-pointer rounded border-slate-300"
                                        [disabled]="getDraftPermission(row).allAccess"
                                        [ngModel]="getDraftPermission(row).t0Access"
                                        (ngModelChange)="updateTierAccess(row, 't0Access', $event)"
                                    />
                                </td>

                                <td class="px-3 py-3 text-center">
                                    <input
                                        type="checkbox"
                                        class="h-4 w-4 cursor-pointer rounded border-slate-300"
                                        [disabled]="getDraftPermission(row).allAccess"
                                        [ngModel]="getDraftPermission(row).t3Access"
                                        (ngModelChange)="updateTierAccess(row, 't3Access', $event)"
                                    />
                                </td>

                                <td class="px-3 py-3 text-center">
                                    <input
                                        type="checkbox"
                                        class="h-4 w-4 cursor-pointer rounded border-slate-300"
                                        [disabled]="getDraftPermission(row).allAccess"
                                        [ngModel]="getDraftPermission(row).t6Access"
                                        (ngModelChange)="updateTierAccess(row, 't6Access', $event)"
                                    />
                                </td>

                                <td class="px-3 py-3 text-center">
                                    <input
                                        type="checkbox"
                                        class="h-4 w-4 cursor-pointer rounded border-slate-300"
                                        [disabled]="getDraftPermission(row).allAccess"
                                        [ngModel]="getDraftPermission(row).dataUploadAccess"
                                        (ngModelChange)="updateTierAccess(row, 'dataUploadAccess', $event)"
                                    />
                                </td>
                            </tr>

                            <tr *ngIf="!getVisibleSelectedCityUsers().length">
                                <td colspan="6" class="px-4 py-8 text-center text-sm text-slate-500">
                                    No users found.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="flex flex-wrap items-center justify-between gap-3">
                    <div class="text-xs text-slate-500">
                        Showing {{ getVisibleSelectedCityUsers().length }} of {{ filteredSelectedCityUsers.length }} users
                    </div>

                    <div class="flex flex-wrap items-center gap-2" *ngIf="getSelectedCityUserPageNumbers().length > 1">
                        <button
                            type="button"
                            class="rounded-xl border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:border-sky-300 hover:text-sky-700 disabled:cursor-not-allowed disabled:opacity-50"
                            [disabled]="cityUserPage === 1"
                            (click)="goToSelectedCityUserPage(cityUserPage - 1)"
                        >
                            Previous
                        </button>

                        <button
                            *ngFor="let page of getSelectedCityUserPageNumbers()"
                            type="button"
                            class="rounded-xl border px-3 py-1.5 text-xs font-semibold transition"
                            [ngClass]="page === cityUserPage ? 'border-sky-300 bg-sky-50 text-sky-700' : 'border-slate-200 text-slate-600 hover:border-sky-300 hover:text-sky-700'"
                            (click)="goToSelectedCityUserPage(page)"
                        >
                            {{ page }}
                        </button>

                        <button
                            type="button"
                            class="rounded-xl border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:border-sky-300 hover:text-sky-700 disabled:cursor-not-allowed disabled:opacity-50"
                            [disabled]="cityUserPage === getSelectedCityUserPageNumbers().length"
                            (click)="goToSelectedCityUserPage(cityUserPage + 1)"
                        >
                            Next
                        </button>
                    </div>
                </div>

                <div class="flex items-center justify-end gap-2 border-t border-slate-100 pt-4">
                    <span *ngIf="cityUsersDirty()" class="mr-auto text-xs font-medium text-amber-600">
                        You have unsaved changes.
                    </span>

                    <button
                        *ngIf="cityUsersDirty()"
                        type="button"
                        class="rounded-xl border border-slate-200 px-4 py-2 text-sm font-medium text-slate-600 transition hover:border-slate-300"
                        (click)="cancelCityUserChanges()"
                    >
                        Cancel changes
                    </button>

                    <button
                        type="button"
                        class="rounded-xl bg-sky-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-sky-700 disabled:cursor-not-allowed disabled:opacity-60"
                        [disabled]="!cityUsersDirty() || savingCityUsers()"
                        (click)="applyCityUserChanges()"
                    >
                        {{ savingCityUsers() ? 'Updating...' : 'Update' }}
                    </button>
                </div>
            </div>
        </p-dialog>

        <p-confirmDialog key="adminDeleteUser" [style]="{ width: '28rem' }"></p-confirmDialog>
    </div>
</div>
